import React, { Fragment } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import TrackVisibility from "react-on-screen";
import withDataLayer from "./../HOCs/withDataLayer";
import LazyLoadImage from "./../Components/LazyLoadImage";

class Item extends React.Component {
    constructor(props){
        super(props);

        this.getClick = this.getClick.bind(this);
        this.getSellerAndPushDataLayer = this.getSellerAndPushDataLayer.bind(this);
        this.pushDataLayer = this.pushDataLayer.bind(this);
        this.onImpression = this.onImpression.bind(this);
    }

    pushDataLayer(eventType, params) {
        this.props.pushDataLayer({
            "event": eventType,
            "bannerName": params.bannerName || "Banner name is not defined",
            "bannerID": params.banner_ids.join(),
            "slideName": params.name,
            "slideID": params.id,
            "advertStart": params.display_from,
            "advertEnd": params.display_to,
            "imgTitle": params.img_title,
            "imgAlt": params.img_alt,
            "clickURL": params.url,
            "seller_id": params.attributes.seller_id,
            "seller": params.sellerName,
            "orderNumber": params.attributes.io_number,
            "auction_event_id": params.attributes.auction_event_id,
            "blog_id": params.attributes.blog_id,
            "item_id": params.attributes.item_id,
            "landing_page_id": params.attributes.landing_page_id
        });
    }

    onImpression() {
        const eventType = "bannerSlideImpression";

        if (this.props.attributes.seller_id) {
            this.getSellerAndPushDataLayer(eventType);
        } else {
            const params = Object.assign({}, this.props);

            this.pushDataLayer(eventType, params);
        }
    }

    getClick() {
        if (this.props.attributes.seller_id) {
            this.getSellerAndPushDataLayer();
        } else {
            const params = Object.assign({}, this.props);

            this.pushDataLayer("bannerSlideClick", params);
        }
    }

    getSellerAndPushDataLayer(eventType = "bannerSlideClick") {
        const { seller_id } = this.props.attributes;

        axios.get(`/api/sellers/${seller_id}/shop`)
            .then((apiResponse) => {
                const params = Object.assign({}, this.props);

                params.sellerName = apiResponse.data.shop_title;
                this.pushDataLayer(eventType, params);
            }).catch((err)=> {
                console.error(err);
            });
    }

    render() {
        const { className, img_file, img_alt, img_title, url ,restUrl } = this.props;

        return (
            <Fragment>
                <TrackVisibility
                    once
                >
                    {({ isVisible }) => isVisible && this.onImpression()}
                </TrackVisibility>
                <div className={`banner-grid-item col ${className}`}>
                    <a
                        href={url}
                        onClick={this.getClick}
                    >
                        <LazyLoadImage
                            src={`${restUrl}/pub/media/aw_rbslider/slides/${img_file}`}
                            alt={img_alt}
                            title={img_title}
                            style={{
                                maxWidth: "100%",
                                height: "auto"
                            }}
                        />
                    </a>
                </div>
            </Fragment>
        );
    }
}

export default withDataLayer(Item);

Item.defaultProps = {
    className: "",
    url: "",
    restUrl: process.env.REST_URL ? process.env.REST_URL : localStorage.getItem("restUrl")
};

Item.propTypes = {
    attributes: PropTypes.shape({
        seller_id: PropTypes.oneOfType([ PropTypes.string, PropTypes.number])
    }),
    pushDataLayer: PropTypes.func,
    img_file: PropTypes.string.isRequired,
    img_alt: PropTypes.string,
    img_title: PropTypes.string,
    url: PropTypes.string,
    className: PropTypes.string,
    restUrl: PropTypes.string
};
